import PaginationButton from '../../paginationButton'
import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight } from 'lucide-react'

interface PaginationArrowsButtonsProps {
  kind?: "prev" | "next"
  setPage: React.Dispatch<React.SetStateAction<number | undefined>>
  currentPage: number
  totalPages: number
}

export default function PaginationArrowsButtons({
  kind = "prev",
  setPage,
  currentPage,
  totalPages 
}: PaginationArrowsButtonsProps) {
  const handleFirstPage = () => setPage(undefined)
  const handlePrevPage = (e: React.MouseEvent) => {
    if (e.detail > 1) return
    setPage(currentPage > 2 ? currentPage - 1 : undefined)
  }

  const handleLastPage = () => setPage(totalPages)
  const handleNextPage = (e: React.MouseEvent) => {
    if (e.detail > 1) return
    setPage(currentPage < totalPages ? currentPage + 1 : totalPages)
  }

  
  if(kind === "prev") {
    return (
      <>
        <PaginationButton className='bg-transparent max-h-4 px-0' onClick={handleFirstPage}>
          <ChevronsLeft strokeWidth={1} />
        </PaginationButton>
        <PaginationButton className='bg-transparent max-h-4 px-0' onClick={handlePrevPage}>
          <ChevronLeft strokeWidth={1} />
        </PaginationButton>
      </>
    )
  }

  return (
    <>
      <PaginationButton className='bg-transparent max-h-4 px-0' onClick={handleNextPage}>
        <ChevronRight strokeWidth={1} />
      </PaginationButton>
      <PaginationButton className='bg-transparent max-h-4 px-0' onClick={handleLastPage}>
        <ChevronsRight strokeWidth={1} />
      </PaginationButton>
    </>
  )
}